import {
	type EventIdentifier,
	isPwaMode,
	isWeb,
	type StakingType,
	TrackingEventType,
	useAnalytics
} from '@capsicum/common';

type FanTokenStakingEntryPointPages = 'partner_page' | 'poll_page' | 'typeform_page' | 'wallet_page';

export type UseFanTokenStakingAnalyticsProps = {
	amount?: number | string;
	currencyId?: null | string;
	currentPage?: FanTokenStakingEntryPointPages;
	eventIdentifier: EventIdentifier;
	networkFee?: null | number;
	partnerId?: string;
	rewardPoints?: number | string;
	status?: string;
	transactionType: StakingType;
};

export const useFanTokenStakingAnalytics = ({
	amount,
	currencyId,
	currentPage,
	eventIdentifier,
	networkFee,
	partnerId,
	rewardPoints,
	status,
	transactionType
}: UseFanTokenStakingAnalyticsProps) => {
	const analytics = useAnalytics();

	const sendFanTokenStakingEvent = () => {
		analytics.sendEvent(TrackingEventType.track, `GA::${eventIdentifier}`, {
			currency: currencyId,
			extra_parameter: transactionType,
			feature: 'fan_token_staking',
			ft_amount: amount,
			is_pwa_mode: isWeb() && isPwaMode(),
			page: currentPage,
			partner_id: partnerId,
			reward_points: rewardPoints,
			service_fee: networkFee,
			status: status
		});
	};

	return { sendFanTokenStakingEvent };
};
